// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"888":"8817c9c1","4289":"8817c9c1","5534":"e4949fd7","9664":"8817c9c1"}[chunkId] + ".chunk.css";
};